import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import styled from "@emotion/styled";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { showSuccessSnackbar, showErrorSnackbar } from "../../redux/slices/snackbar";

import {
  Alert as MuiAlert,
  Box,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  CardContent,
  CircularProgress,
  CardHeader,
  Typography,
} from "@mui/material";
import { spacing } from "@mui/system";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, FormProvider } from "react-hook-form";

import SaveCancel from "../../components/SaveCancel";
import useLead from "../../hooks/useLead";
import LeadFields from "./components/LeadFields";

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Card = styled(MuiCard)(spacing);

const Alert = styled(MuiAlert)(spacing);

const validationSchema = Yup.object().shape({
  tenant: Yup.object()
    .shape({
      label: Yup.string().required(),
      value: Yup.string().required(),
    })
    .nullable()
    .required(),
  branchName: Yup.object()
    .shape({
      label: Yup.string().required(),
      value: Yup.string().required(),
    })
    .nullable()
    .required(),
  employee: Yup.object()
    .shape({
      label: Yup.string().required(),
      value: Yup.string().required(),
    })
    .nullable()
    .required(),
  status: Yup.string().required("Required"),
  leadType: Yup.string().required("Required"),
  mobileNo: Yup.string()
    .required("Required")
    .matches(/^\d{10}$/, "Must be a valid phone number with up to 10 digits"),
  address: Yup.string().required("Required"),
  email: Yup.string().required("Required"),
  customerName: Yup.string().required("Required"),
});

function EditLead() {
  const dispatch = useDispatch();

  const { getLead, lead, updateLead, isSubmitting } = useLead();

  React.useEffect(() => {
    if (Object.keys(lead).length !== 0) {
      console.log(lead.status, "lead.status");
      const initialValues = {
        leadId: lead.leadId,
        tenant: {
          label: lead.tenant.tenantName,
          value: lead.tenant.tenantId,
        },
        branchName: {
          label: lead.branch.branchName,
          value: lead.branch.branchId,
        },
        employee: {
          label: lead.employee.employeeName,
          value: lead.employee.employeeId,
        },
        leadType: lead.leadType,
        comments: lead.comments,
        status: lead.status,
        address: lead.address,
        mobileNo: lead.mobileNo,
        email: lead.email,
        customerName: lead.customerName,
      };
      reset(initialValues);
    }
  }, [lead]);

  const methods = useForm({
    resolver: yupResolver(validationSchema),
  });

  const [status] = useState({
    sent: false,
  });

  const { state } = useLocation();
  console.log(state, "location");
  const { t } = useTranslation();
  const navigate = useNavigate();

  const {
    reset,
    handleSubmit,
    formState: {},
  } = methods;

  const onSubmit = async (data) => {
    try {
      data["tenant"] = {
        tenantId: data.tenant.value,
      };

      data["branch"] = {
        branchId: data.branchName.value,
      };
      data["employee"] = {
        employeeId: data.employee.value,
      };
      await updateLead(data);

      dispatch(showSuccessSnackbar("Lead  edited successfully!"));
      navigate("/leads/list");
    } catch (err) {
      console.log(err, "ddddddddddddd");
      dispatch(showErrorSnackbar("Failed to edit lead "));
    }
  };

  const cancelBtn = () => {
    navigate("/leads/list");
  };

  const breadCrump = () => {
    return (
      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Typography>lead</Typography>
        <Typography>Edit</Typography>
      </Breadcrumbs>
    );
  };

  const fetchData = async () => {
    await getLead(state.id);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <Card mb={6}>
          <CardHeader title={t("edit_lead")} subheader={breadCrump()} />
          <CardContent>
            {status && status.sent && (
              <Alert severity="success" my={3}>
                lead updated successfully!
              </Alert>
            )}

            {isSubmitting ? (
              <Box display="flex" justifyContent="center" my={6}>
                <CircularProgress />
              </Box>
            ) : (
              <form onSubmit={handleSubmit(onSubmit)}>
                <LeadFields hideAssignee={true} userNameDisabled={true} />
                <SaveCancel cancelBtn={cancelBtn} resetForm={reset} />
              </form>
            )}
          </CardContent>
        </Card>
      </FormProvider>
    </React.Fragment>
  );
}

export default EditLead;
